// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-portal {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Loading State */
.portal-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.portal-loading p {
  color: white;
  font-size: 1.1rem;
  font-weight: 500;
}

/* Error State */
.portal-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
  padding: 40px;
}

.portal-error h2 {
  font-size: 2rem;
  margin-bottom: 15px;
}

.portal-error p {
  font-size: 1.1rem;
  margin-bottom: 30px;
  opacity: 0.9;
}

.back-home-btn {
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.back-home-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
}

/* Header */
.portal-header {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 30px 40px;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.studio-info h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  margin: 0 0 5px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.studio-info p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.2rem;
  margin: 0;
}

.share-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.share-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
}

/* Client Stats */
.client-stats {
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 25px;
}

.stat-item {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 30px;
  display: flex;
  align-items: center;
  gap: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
}

.stat-icon {
  font-size: 2.5rem;
  color: white;
  opacity: 0.9;
}

.stat-item h3 {
  font-size: 2.2rem;
  font-weight: 700;
  color: white;
  margin: 0 0 5px 0;
}

.stat-item p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1rem;
  margin: 0;
  font-weight: 500;
}

/* Sessions Section */
.sessions-section {
  padding: 0 40px 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.sessions-section h2 {
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
  margin-bottom: 25px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.sessions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.session-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-radius: 15px;
  padding: 25px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: all 0.3s ease;
}

.session-card:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-3px);
}

.session-card.active {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
}

.session-info h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: white;
  margin: 0 0 8px 0;
}

.session-info p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.95rem;
  margin: 0 0 15px 0;
}

.session-stats {
  display: flex;
  gap: 15px;
}

.session-stats span {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
}

/* Gallery Controls */
.gallery-controls {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding: 30px 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.search-section {
  margin-bottom: 20px;
}

.search-box {
  position: relative;
  max-width: 500px;
}

.search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
}

.search-box input {
  width: 100%;
  padding: 15px 15px 15px 45px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  transition: all 0.3s ease;
}

.search-box input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.search-box input:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.15);
}

.filters-section {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-icon {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
}

.filter-group select {
  padding: 12px 15px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
}

.filter-group select:focus {
  outline: none;
  border-color: rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.15);
}

.filter-group select option {
  background: #2d3748;
  color: white;
}

.view-controls {
  display: flex;
  gap: 5px;
  margin-left: auto;
}

.view-btn {
  width: 40px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.view-btn.active {
  border-color: rgba(255, 255, 255, 0.6);
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.view-btn:hover {
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
}

/* Media Gallery */
.media-gallery {
  padding: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.empty-state {
  text-align: center;
  padding: 80px 40px;
  color: rgba(255, 255, 255, 0.8);
}

.empty-icon {
  font-size: 4rem;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 20px;
}

.empty-state h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin: 0 0 10px 0;
}

.empty-state p {
  font-size: 1.1rem;
  margin: 0;
}

.media-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 25px;
}

.media-container.list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.media-item {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-radius: 15px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
}

.media-item:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.media-preview {
  position: relative;
  aspect-ratio: 16/9;
  overflow: hidden;
}

.media-preview img,
.media-preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-preview {
  position: relative;
  width: 100%;
  height: 100%;
}

.video-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.media-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.media-item:hover .media-overlay {
  opacity: 1;
}

.overlay-actions {
  display: flex;
  gap: 10px;
}

.overlay-btn {
  width: 45px;
  height: 45px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  color: #2d3748;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.overlay-btn:hover {
  background: #667eea;
  color: white;
  transform: scale(1.1);
}

.overlay-btn.favorite.active {
  background: #e53e3e;
  color: white;
}

.favorite-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background: #e53e3e;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
}

.media-info {
  padding: 20px;
}

.media-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: white;
  margin: 0 0 8px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.media-meta {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  margin: 0 0 10px 0;
}

.media-details {
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.6);
}

.file-size,
.upload-date {
  background: rgba(255, 255, 255, 0.1);
  padding: 4px 8px;
  border-radius: 6px;
}

.media-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.tag {
  background: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
}

/* List View Styles */
.media-container.list .media-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 15px;
}

.media-container.list .media-preview {
  width: 120px;
  height: 80px;
  flex-shrink: 0;
  aspect-ratio: unset;
}

.media-container.list .media-info {
  flex: 1 1;
  padding: 0;
}

.media-container.list .media-name {
  white-space: normal;
}

/* Media Viewer Modal */
.media-viewer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.media-viewer {
  background: white;
  border-radius: 20px;
  width: 100%;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
}

.viewer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 2px solid #f7fafc;
  background: white;
}

.media-info-header h3 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #2d3748;
  margin: 0 0 5px 0;
}

.media-info-header p {
  color: #4a5568;
  font-size: 0.9rem;
  margin: 0;
}

.viewer-actions {
  display: flex;
  gap: 10px;
}

.favorite-btn,
.share-btn,
.close-btn {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.favorite-btn {
  background: #f7fafc;
  color: #4a5568;
}

.favorite-btn.active {
  background: #e53e3e;
  color: white;
}

.share-btn {
  background: #f7fafc;
  color: #4a5568;
}

.close-btn {
  background: #fed7d7;
  color: #742a2a;
}

.favorite-btn:hover,
.share-btn:hover {
  transform: scale(1.1);
}

.close-btn:hover {
  background: #feb2b2;
}

.viewer-content {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #f7fafc;
}

.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  z-index: 10;
}

.nav-btn:hover {
  background: rgba(0, 0, 0, 0.9);
  transform: translateY(-50%) scale(1.1);
}

.nav-btn.prev {
  left: 20px;
}

.nav-btn.next {
  right: 20px;
}

.media-display {
  max-width: 100%;
  max-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.media-display img,
.media-display video {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.viewer-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  border-top: 2px solid #f7fafc;
  background: white;
}

.media-counter {
  color: #4a5568;
  font-weight: 600;
}

.download-notice {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #718096;
  font-size: 0.9rem;
}

.download-notice svg {
  color: #a0aec0;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .media-container {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (max-width: 768px) {
  .portal-header {
    padding: 20px;
  }
  
  .header-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .client-stats {
    padding: 20px;
  }
  
  .sessions-section {
    padding: 0 20px 20px;
  }
  
  .gallery-controls {
    padding: 20px;
  }
  
  .filters-section {
    flex-direction: column;
    gap: 15px;
  }
  
  .view-controls {
    margin-left: 0;
  }
  
  .media-gallery {
    padding: 20px;
  }
  
  .media-container {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 15px;
  }
  
  .media-viewer {
    max-width: 95vw;
    max-height: 95vh;
  }
  
  .viewer-header {
    padding: 15px 20px;
  }
  
  .viewer-footer {
    padding: 15px 20px;
  }
  
  .nav-btn {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
  
  .nav-btn.prev {
    left: 10px;
  }
  
  .nav-btn.next {
    right: 10px;
  }
}

@media (max-width: 480px) {
  .portal-header {
    padding: 15px;
  }
  
  .studio-info h1 {
    font-size: 2rem;
  }
  
  .client-stats {
    padding: 15px;
  }
  
  .sessions-section {
    padding: 0 15px 15px;
  }
  
  .gallery-controls {
    padding: 15px;
  }
  
  .media-gallery {
    padding: 15px;
  }
  
  .media-container {
    grid-template-columns: 1fr;
  }
  
  .media-container.list .media-item {
    flex-direction: column;
    text-align: center;
  }
  
  .media-container.list .media-preview {
    width: 100%;
    height: 200px;
  }
  
  .media-viewer {
    max-width: 100vw;
    max-height: 100vh;
    border-radius: 0;
  }
  
  .viewer-header {
    padding: 10px 15px;
  }
  
  .viewer-footer {
    padding: 10px 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/photo-studio/ClientPortal.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,mEAAmE;AACrE;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA,WAAW;AACX;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,8CAA8C;EAC9C,iDAAiD;EACjD,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".client-portal {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* Loading State */\n.portal-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top: 4px solid white;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.portal-loading p {\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 500;\n}\n\n/* Error State */\n.portal-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  text-align: center;\n  padding: 40px;\n}\n\n.portal-error h2 {\n  font-size: 2rem;\n  margin-bottom: 15px;\n}\n\n.portal-error p {\n  font-size: 1.1rem;\n  margin-bottom: 30px;\n  opacity: 0.9;\n}\n\n.back-home-btn {\n  padding: 12px 24px;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.back-home-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n/* Header */\n.portal-header {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 30px 40px;\n}\n\n.header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.studio-info h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: white;\n  margin: 0 0 5px 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.studio-info p {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 1.2rem;\n  margin: 0;\n}\n\n.share-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 24px;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.share-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n}\n\n/* Client Stats */\n.client-stats {\n  padding: 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 25px;\n}\n\n.stat-item {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  padding: 30px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n}\n\n.stat-item:hover {\n  transform: translateY(-5px);\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.stat-icon {\n  font-size: 2.5rem;\n  color: white;\n  opacity: 0.9;\n}\n\n.stat-item h3 {\n  font-size: 2.2rem;\n  font-weight: 700;\n  color: white;\n  margin: 0 0 5px 0;\n}\n\n.stat-item p {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1rem;\n  margin: 0;\n  font-weight: 500;\n}\n\n/* Sessions Section */\n.sessions-section {\n  padding: 0 40px 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.sessions-section h2 {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: white;\n  margin-bottom: 25px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.sessions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 20px;\n}\n\n.session-card {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-radius: 15px;\n  padding: 25px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.session-card:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: translateY(-3px);\n}\n\n.session-card.active {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.session-info h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: white;\n  margin: 0 0 8px 0;\n}\n\n.session-info p {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.95rem;\n  margin: 0 0 15px 0;\n}\n\n.session-stats {\n  display: flex;\n  gap: 15px;\n}\n\n.session-stats span {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n/* Gallery Controls */\n.gallery-controls {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 30px 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.search-section {\n  margin-bottom: 20px;\n}\n\n.search-box {\n  position: relative;\n  max-width: 500px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1rem;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 15px 15px 15px 45px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 12px;\n  font-size: 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  transition: all 0.3s ease;\n}\n\n.search-box input::placeholder {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.search-box input:focus {\n  outline: none;\n  border-color: rgba(255, 255, 255, 0.5);\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.filters-section {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filter-icon {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 1rem;\n}\n\n.filter-group select {\n  padding: 12px 15px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 10px;\n  font-size: 1rem;\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 150px;\n}\n\n.filter-group select:focus {\n  outline: none;\n  border-color: rgba(255, 255, 255, 0.5);\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.filter-group select option {\n  background: #2d3748;\n  color: white;\n}\n\n.view-controls {\n  display: flex;\n  gap: 5px;\n  margin-left: auto;\n}\n\n.view-btn {\n  width: 40px;\n  height: 40px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.7);\n  border-radius: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.view-btn.active {\n  border-color: rgba(255, 255, 255, 0.6);\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n}\n\n.view-btn:hover {\n  border-color: rgba(255, 255, 255, 0.5);\n  color: white;\n}\n\n/* Media Gallery */\n.media-gallery {\n  padding: 40px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 80px 40px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.empty-icon {\n  font-size: 4rem;\n  color: rgba(255, 255, 255, 0.5);\n  margin-bottom: 20px;\n}\n\n.empty-state h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: white;\n  margin: 0 0 10px 0;\n}\n\n.empty-state p {\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.media-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 25px;\n}\n\n.media-container.list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.media-item {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-radius: 15px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.media-item:hover {\n  transform: translateY(-5px);\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.media-preview {\n  position: relative;\n  aspect-ratio: 16/9;\n  overflow: hidden;\n}\n\n.media-preview img,\n.media-preview video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.video-preview {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.video-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n}\n\n.media-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.media-item:hover .media-overlay {\n  opacity: 1;\n}\n\n.overlay-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.overlay-btn {\n  width: 45px;\n  height: 45px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.9);\n  color: #2d3748;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.overlay-btn:hover {\n  background: #667eea;\n  color: white;\n  transform: scale(1.1);\n}\n\n.overlay-btn.favorite.active {\n  background: #e53e3e;\n  color: white;\n}\n\n.favorite-indicator {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 30px;\n  height: 30px;\n  background: #e53e3e;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9rem;\n}\n\n.media-info {\n  padding: 20px;\n}\n\n.media-name {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: white;\n  margin: 0 0 8px 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.media-meta {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.9rem;\n  margin: 0 0 10px 0;\n}\n\n.media-details {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 10px;\n  font-size: 0.8rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.file-size,\n.upload-date {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 4px 8px;\n  border-radius: 6px;\n}\n\n.media-tags {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.tag {\n  background: rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.9);\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n/* List View Styles */\n.media-container.list .media-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 15px;\n}\n\n.media-container.list .media-preview {\n  width: 120px;\n  height: 80px;\n  flex-shrink: 0;\n  aspect-ratio: unset;\n}\n\n.media-container.list .media-info {\n  flex: 1;\n  padding: 0;\n}\n\n.media-container.list .media-name {\n  white-space: normal;\n}\n\n/* Media Viewer Modal */\n.media-viewer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.media-viewer {\n  background: white;\n  border-radius: 20px;\n  width: 100%;\n  max-width: 90vw;\n  max-height: 90vh;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n}\n\n.viewer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 30px;\n  border-bottom: 2px solid #f7fafc;\n  background: white;\n}\n\n.media-info-header h3 {\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin: 0 0 5px 0;\n}\n\n.media-info-header p {\n  color: #4a5568;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.viewer-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.favorite-btn,\n.share-btn,\n.close-btn {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.favorite-btn {\n  background: #f7fafc;\n  color: #4a5568;\n}\n\n.favorite-btn.active {\n  background: #e53e3e;\n  color: white;\n}\n\n.share-btn {\n  background: #f7fafc;\n  color: #4a5568;\n}\n\n.close-btn {\n  background: #fed7d7;\n  color: #742a2a;\n}\n\n.favorite-btn:hover,\n.share-btn:hover {\n  transform: scale(1.1);\n}\n\n.close-btn:hover {\n  background: #feb2b2;\n}\n\n.viewer-content {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  background: #f7fafc;\n}\n\n.nav-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 50px;\n  height: 50px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.nav-btn:hover {\n  background: rgba(0, 0, 0, 0.9);\n  transform: translateY(-50%) scale(1.1);\n}\n\n.nav-btn.prev {\n  left: 20px;\n}\n\n.nav-btn.next {\n  right: 20px;\n}\n\n.media-display {\n  max-width: 100%;\n  max-height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.media-display img,\n.media-display video {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.viewer-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 30px;\n  border-top: 2px solid #f7fafc;\n  background: white;\n}\n\n.media-counter {\n  color: #4a5568;\n  font-weight: 600;\n}\n\n.download-notice {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #718096;\n  font-size: 0.9rem;\n}\n\n.download-notice svg {\n  color: #a0aec0;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .media-container {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .portal-header {\n    padding: 20px;\n  }\n  \n  .header-content {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n  \n  .client-stats {\n    padding: 20px;\n  }\n  \n  .sessions-section {\n    padding: 0 20px 20px;\n  }\n  \n  .gallery-controls {\n    padding: 20px;\n  }\n  \n  .filters-section {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .view-controls {\n    margin-left: 0;\n  }\n  \n  .media-gallery {\n    padding: 20px;\n  }\n  \n  .media-container {\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 15px;\n  }\n  \n  .media-viewer {\n    max-width: 95vw;\n    max-height: 95vh;\n  }\n  \n  .viewer-header {\n    padding: 15px 20px;\n  }\n  \n  .viewer-footer {\n    padding: 15px 20px;\n  }\n  \n  .nav-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n  \n  .nav-btn.prev {\n    left: 10px;\n  }\n  \n  .nav-btn.next {\n    right: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .portal-header {\n    padding: 15px;\n  }\n  \n  .studio-info h1 {\n    font-size: 2rem;\n  }\n  \n  .client-stats {\n    padding: 15px;\n  }\n  \n  .sessions-section {\n    padding: 0 15px 15px;\n  }\n  \n  .gallery-controls {\n    padding: 15px;\n  }\n  \n  .media-gallery {\n    padding: 15px;\n  }\n  \n  .media-container {\n    grid-template-columns: 1fr;\n  }\n  \n  .media-container.list .media-item {\n    flex-direction: column;\n    text-align: center;\n  }\n  \n  .media-container.list .media-preview {\n    width: 100%;\n    height: 200px;\n  }\n  \n  .media-viewer {\n    max-width: 100vw;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n  \n  .viewer-header {\n    padding: 10px 15px;\n  }\n  \n  .viewer-footer {\n    padding: 10px 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
